<p>プラン確認</p>

<div>
  <div style="border: solid #5454cd 2px">
    デモモード用
    <button id="ssn-test-plan-review-demo-start" class="testButton" (click)="planReviewTestDemo('0' + testDemo1Number)">
      デモモード
    </button>
    カート番号:<input
      id="ssn-test-plan-review-demo-start-number"
      type="number"
      min="1"
      max="9"
      [(ngModel)]="testDemo1Number"
    />
    <button
      id="ssn-test-plan-review-demo-start2"
      class="testButton"
      (click)="planReviewTestDemo('2' + testDemo2Number)"
    >
      デモモード2
    </button>
    カート番号:<input
      id="ssn-test-plan-review-demo-start-number2"
      type="number"
      min="1"
      max="9"
      [(ngModel)]="testDemo2Number"
    />
  </div>
  <button
    id="ssn-test-plan-review-from-p030"
    class="testButton"
    (click)="planReviewTestFromPrevPage('P030', 'R01', true)"
  >
    R01P030からの遷移
  </button>

  <button id="ssn-test-plan-review-from-p042" class="testButton" (click)="planReviewTestFromPlanList()">
    R01P042からの遷移
  </button>

  <button id="ssn-test-plan-review-from-p080" class="testButton" (click)="planReviewTestFromLater('P070', 'R01')">
    R01P080からの遷移
  </button>

  <button id="ssn-test-plan-review-show-agreement" class="testButton" (click)="planReviewTestShowAgreement()">
    規約モーダル表示
  </button>

  <button
    id="ssn-test-plan-review-invalid-from-p030"
    class="testButton"
    (click)="planReviewTestFromPrevPage('P030', 'R01', false)"
  >
    プラン無効
  </button>

  <button id="ssn-test-plan-review-valid-english" class="testButton" (click)="planReviewTestLanguage('en')">
    英語表示
  </button>

  <button id="ssn-tesnt-plan-review-pos-jp" class="testButton" (click)="planReviewTestPOSCountryCode('JP')">
    日本オフィス
  </button>

  <button id="ssn-tesnt-plan-review-pos-ca" class="testButton" (click)="planReviewTestPOSCountryCode('CA')">
    カナダオフィス
  </button>

  <button id="ssn-test-plan-review-upsell" class="testButton" (click)="planReviewTestUpsell('P030', 'R01')">
    アップセル
  </button>

  <button id="ssn-test-plan-review-biz-office" class="testButton" (click)="planReviewTestCreationPOS('TYONH08BZ')">
    Bizオフィス
  </button>

  <button id="ssn-test-plan-review-upsell-biz-office" class="testButton" (click)="planReviewTestUpsellBizOffice()">
    アップセル×Bizオフィス
  </button>

  <button id="ssn-test-plan-review-biz-plan" class="testButton" (click)="planReviewTestBizAgreement()">
    Bizプラン
  </button>

  <button id="ssn-test-plan-review-pet-error" class="testButton" (click)="planReviewTestPetError()">
    ペットらくのりエラー
  </button>

  <button
    id="ssn-test-plan-review-from-p031"
    class="testButton"
    (click)="planReviewTestFromPrevPage('P031', 'R01', true)"
  >
    R01P031からの遷移
  </button>
</div>

<!--

<button id="ssn-test-plan-review1" class="testButton" (click)="planReviewTest1('P080', 'R01')">
  プラン確認了画面へ
</button>

<button id="ssn-test-plan-review2" class="testButton" (click)="planReviewTest6('P080', 'R01')">搭乗者未登録</button>
<button id="ssn-test-plan-review3" class="testButton" (click)="planReviewTest5('P080', 'R01')">手荷物ルール</button>
<button id="ssn-test-plan-review4" class="testButton" (click)="planReviewTest3('P080', 'R01')">サービス登録なし</button>
<button id="ssn-test-plan-review5" class="testButton" (click)="planReviewTest4('P080', 'R01')">unsave</button>
<button id="ssn-test-plan-review6" class="testButton" (click)="planReviewTestAgree('KR', '', '')">
  同意:韓国 前画面無し
</button>
<button id="ssn-test-plan-review7" class="testButton" (click)="planReviewTestAgree('KR', 'P033', 'R01')">
  同意:韓国
</button>
<button id="ssn-test-plan-review8" class="testButton" (click)="planReviewTestAgree('HK', '', '')">
  同意:香港 前画面無し
</button>
<button id="ssn-test-plan-review9" class="testButton" (click)="planReviewTestAgree('HK', 'P033', 'R01')">
  同意:香港
</button>
<button id="ssn-test-plan-review10" class="testButton" (click)="planReviewTest1('P030', 'R01', false)">
  往復空席照会結果(国際)からの遷移
</button>
<button id="ssn-test-plan-review11" class="testButton" (click)="planReviewTest1('P033', 'R01', false)">
  複雑空席照会結果(国際)からの遷移
</button>
<button id="ssn-test-plan-review12" class="testButton" (click)="planReviewTest1('P042', 'R01')">
  プランリストからの遷移
</button>
<button id="ssn-test-plan-review13" class="testButton" (click)="planReviewTest7('P080', 'R01')">未入力あり</button>

-->
